var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// CURRENT_USER_CARE_PODS
var CURRENT_USER_CARE_PODS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CurrentUserCarePods {\n    current_user {\n      id\n      care_pods {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query CurrentUserCarePods {\n    current_user {\n      id\n      care_pods {\n        id\n        name\n      }\n    }\n  }\n"])));
export var useCurrentUserCarePodsQuery = function (options) {
    return useQuery(CURRENT_USER_CARE_PODS, options);
};
export default CURRENT_USER_CARE_PODS;
var templateObject_1;
